<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item :to="{ path: 'goodsCatalog' }">物料目录</el-breadcrumb-item>
      <el-breadcrumb-item>编辑物料目录</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-form ref="form" :model="form" label-width="160px">
        <el-form-item label="物料编码">
          <el-input v-if="showBtn<1||showBtn==3" v-model="form.gcode" maxlength="100" placeholder="请输入客户物料编码" show-word-limit></el-input>
          <span v-else>{{form.gcode}}</span>
        </el-form-item>
        <el-form-item label="物料名称" :required="true">
          <el-input v-if="showBtn<1||showBtn==3" v-model="form.title" placeholder="请输入物料名称" maxlength="100" show-word-limit></el-input>
          <span v-else>{{form.title}}</span>
        </el-form-item>
        <el-form-item label="物料描述/规格">
          <el-input v-if="showBtn<1||showBtn==3" type="textarea" v-model="form.remark" maxlength="250" show-word-limit></el-input>
          <span v-else>{{form.remark}}</span>
        </el-form-item>
        <el-form ref="form" inline :model="form" label-width="160px">
          <el-form-item label="单位" :required="true">
            <el-input v-if="showBtn<1||showBtn==3" v-model="form.unit" maxlength="50" show-word-limit></el-input>
            <span v-else>{{form.unit}}</span>
          </el-form-item>
        </el-form>
        <el-form-item label="采购员" :required="true" v-if="showBtn<1">
          <el-select v-model="form.buyer" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in buyer"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" v-if="showBtn<1||showBtn==3">
          <el-button @click="saveGoods">保存</el-button>
        </el-form-item>
    </el-form>
  </div>
</el-card>
</template>
<script>
import goodsFunction from "@/api/goods"
import userFunction from "@/api/user"
export default {
  data() {
    return {
      showBtn:sessionStorage.getItem('roleid'),
      buyer:[],
      form:{
        id:'',
        gcode:'',
        title:'',
        keywords:'',
        scale:'',
        remark:'',
        price:0.00,
        unit:'',
        validityTime:'',
        buyer:'',
        status:1,
        examine:0,
        examineMsg:'',
        vcode:sessionStorage.getItem('token'),
      },
    };
  },
  methods:{
    getGoods(){
      goodsFunction.getGoodsCatalog(this.form,this).then(res=>{
        this.form.id = res.id
        this.form.gcode = res.gcode
        this.form.title = res.title
        this.form.keywords = res.keywords
        this.form.remark = res.remark
        this.form.price = res.price
        this.form.scale = res.scale
        this.form.unit = res.unit
        this.form.validityTime = res.validity_time
        this.form.imglist = res.imglist
        this.form.buyer = res.buyer
        this.form.examine = res.examine
        this.form.examineMsg = res.examineMsg
        this.form.status = res.status
      })
    },
    saveGoods(){
      if(this.showBtn<1||this.showBtn==3){
        this.form.examine = 0
      }
      goodsFunction.saveGoodsCatalog(this.form,this).then(res=>{
        this.$router.push('/home/goodsCatalog')
      })
    },
    getBuyer(){
      userFunction.getBuyer({vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.buyer = res
      })
    },
  },
  mounted () {
    this.getBuyer()
    this.form.id = this.$route.query.id
    this.getGoods()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/goods/editGoodsCatalog.vue